<template>
  <div class="enroll-change-update"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="detailInfo">
      <div class="main-cont">
        <el-form size="mini"
                 label-width="90px"
                 label-suffix="：">
          <el-form-item label="原教学点">
            <span>{{detailInfo.siteName}}</span>
          </el-form-item>
          <el-form-item label="变更教学点">
            <el-select v-model="form.siteId"
                       size="mini"
                       filterable>
              <template v-if="detailInfo && detailInfo.sites">
                <el-option v-for="site in detailInfo.sites"
                           :key="site.id"
                           :label="site.name"
                           :value="site.id"/>
              </template>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer">
        <el-button size="mini"
                   type="primary"
                   :disabled="committing"
                   @click="handleApply">提交保存</el-button>
        <el-button size="mini"
                   type="default"
                   @click="handleClose">关闭窗口</el-button>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>请求数据加载失败</div>
        <el-button type="text"
                   @click="loadDetailInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import Hint from '../../../../../../elements/Hint'
export default {
  name: 'EnrollChangeUpdate',
  components: {
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      detailInfo: null,
      form: {
        siteId: ''
      },
      committing: false
    }
  },
  methods: {
    loadDetailInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enroll/change/student/update/detailInfo',
        method: 'post',
        data: this.$qs.stringify({
          postId: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.detailInfo = response.data['detailInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('教学点数据加载失败')
      }).finally(() => {
        this.loading = false
      })
    },
    handleApply () {
      if (!this.form.siteId) {
        this.$message.warning('请选择变更教学点')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/enroll/change/student/update/submit',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          postId: this.rowData.id
        }, this.form))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.$nextTick(() => {
                this.$emit('hidePopoverAndRefresh')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  mounted () {
    this.loadDetailInfo()
  },
  watch: {
    visible (val) {
      if (val) {
        Object.keys(this.form).forEach(key => {
          this.form[key] = ''
        })
        this.$nextTick(() => {
          this.loadDetailInfo()
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .enroll-change-update {
    min-height: 160px;
    & > .main-cont {
      padding: 20px 30px 20px 15px;
      .el-form {
        .el-form-item {
          margin-bottom: 12px;
          &:last-child {
            margin-bottom: 0;
          }
          .el-form-item__label {
            font-size: 12px;
          }
          .el-form-item__content {
            font-size: 12px;
            .el-select {
              width: 100%;
            }
          }
        }
      }
    }
    & > .footer {
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
    .layout-hint {
      height: 160px;
    }
  }
</style>
